import { tracked } from '@glimmer/tracking';

import type { SortOrderDirection } from 'webapp-types';
import { OrderDirection } from 'webapp/enums/enums';

import FilterSort from 'webapp/models-custom/filter-sort/base';

export default class FilterSortQueryPreview extends FilterSort<SomeDataObject> {
	@tracked override sortProp = 'dateValue';
	@tracked override sortOrder: SortOrderDirection = OrderDirection.DESC;

	override searchProps = {};
}
